import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
// import { Button, Stack, Typography } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setPDFData } from '../../../../../components/hooks/printPdf/pdfData';
import { Button, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Backdrop } from '@mui/material';
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';


const CustomerInfo = ({ options, setOptions,setOrderDetails,orderDetails1,supplierData, data, setData, postData, setPostData, docName, outletId ,setDocName}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
console.log(options,"savedatatw1223");

  // Totals
  const totalAmt = orderDetails1.reduce((acc, item) => acc + parseFloat(item.totalAmt || 0), 0);
  const gstAmt = orderDetails1.reduce((acc, item) => acc + parseFloat(item.gstAmt || 0), 0);
  const cessAmt = orderDetails1.reduce((acc, item) => acc + parseFloat(item.cessAmt || 0), 0);
  // const totalAmt = data[0]?.data.reduce((acc, item) => acc + parseFloat(item.totalAmt || 0), 0);
  // const gstAmt = data[0]?.data.reduce((acc, item) => acc + parseFloat(item.gstAmt || 0), 0);
  // const cessAmt = data[0]?.data.reduce((acc, item) => acc + parseFloat(item.cessAmt || 0), 0);
  const netTotal = parseFloat(totalAmt + gstAmt).toFixed(2);
  const roundOff = (Math.round(netTotal) - netTotal).toFixed(2);

  // Convert numbers to words
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion'];

  const convertNumber = (num) => {
    if (num === 0) return 'Zero';
    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };

  const Design = ({ title, value }) => (
    <div className="flex items-center justify-between px-2 py-1">
      <Typography variant="body1" sx={{ fontWeight: 600 }}>{title}</Typography>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>{parseFloat(value).toFixed(2)}</Typography>
    </div>
  );

  // Cancel (delete) transaction
  const cancelTransaction = () => {
    axios.post(`/v1/issue_transfer_temp/cancel`, {
      outlet_id: outletId,
      docno: docName
    })
      .then(() => {
        dispatch(setSnackbar(true, 'success', 'Transaction cancelled successfully!'));
        setData([]);
        setOpenDeleteDialog(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, 'error', err.response?.data?.errors?.[0]?.message || 'Failed to cancel transaction'));
      });
  };
  function getPoData() {
    axios
      .get("/v1/indent/order")
      .then((res) => {
        setDocName(res.data.Docno); // Set the PO number to state
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  // Submit indent
//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         indent_date: new Date().toISOString().split("T")[0],
//         wh_id: postData?.wh_id,
//         // wh_id: postData?.wh_id,
//         total_items: data[0]?.data.length,
//         manual_flag: true,
//         outlet_id: outletId || 0,
//         total_order_qty: data.reduce((sum, item) => sum + item.order_qty, 0),
//         total_amt: totalAmt.toFixed(2),
//         total_gst: gstAmt.toFixed(2),
//         indent_order_details: data[0]?.data.map((item) => ({
//           indent_date: new Date().toISOString().split("T")[0],
//           prod_id: item.id,
//           order_qty: item.order_qty,
//           cat_id: item.cat_id || 1,
//           sub_cat_id: item.sub_cat,
//           head_id: item.head_id || 1,
//           type_design_id: item.type,
//           uom_id: item.uom,
//           // barcode: item.barcode || "0",
//           mrp: item.mrp,
//           gst: item.gst

       
//         }))
//       };

//       setPostData(payload);

//       await axios.post("/v1/indent/order", payload);
//       dispatch(setSnackbar(true, 'success', 'Sales reorder processed successfully!'));
//       setData([]);
//        setOrderDetails([])
// getPoData()
//     } catch (error) {
//       dispatch(setSnackbar(true, 'error', error.response?.data?.errors?.[0]?.message || 'Order qty is required'));
//     }
//   };

const handleSubmit = async () => {
  try {
    const filteredItems = data[0]?.data.filter(item => item.order_qty); // Only items with order_qty filled


    if (!filteredItems?.length) {
      dispatch(setSnackbar(true, 'error', 'Order qty is required'));
      return;
    }

    const payload = {
      indent_date: new Date().toISOString().split("T")[0],
      wh_id: postData?.wh_id,
      total_items: filteredItems.length,
      manual_flag: true,
      outlet_id: options?.customer?.id || 0,
      // outlet_id: outletId || 0,
      total_order_qty: filteredItems.reduce((sum, item) => sum + Number(item.order_qty || 0), 0),
      total_amt: totalAmt.toFixed(2),
      total_gst: gstAmt.toFixed(2),
      indent_order_details: filteredItems.map((item) => ({
        indent_date: new Date().toISOString().split("T")[0],
        prod_id: item.id,
        order_qty: item.order_qty,
        cat_id: item.cat_id || 1,
        sub_cat_id: item.sub_cat,
        head_id: item.head_id || 1,
        type_design_id: item.type,
        uom_id: item.uom,
        mrp: item.mrp,
        gst: item.gst
      }))
    };

    setPostData(payload);

    await axios.post("/v1/indent/order", payload);
    dispatch(setSnackbar(true, 'success', 'Indent processed successfully!'));
    setData([]);
    setOrderDetails([]);
    getPoData();

  } catch (error) {
    dispatch(setSnackbar(true, 'error', error.response?.data?.errors?.[0]?.message || 'Order qty is required'));
  }
};

  // Generate PDF
  const fetchBill = () => {
    axios.post(`/v1/packing/issue/pdf`, { docno: docName })
      .then((res) => {
        const name = `BillNo_${encodeURIComponent(docName)}`;
        dispatch(setPDFData({
          tableData: data.map(val => ({
            pro_name: val.pro_name,
            hsn: val.hsn,
            sale_rate: val.sale_rate,
            qty: val.qty,
            disc1: val.disc1,
            cgstPerc: val.gst,
            cgstAmnt: val.gstAmt,
            totalAmt: val.totalAmt
          })),
          TotalData: {
            sub_total: totalAmt,
            gst: gstAmt,
            totalAmount: parseFloat(Math.round(netTotal)).toFixed(2),
            roundOff,
            totalText: convertNumber(Math.round(netTotal))
          },
          companyInfo: res.data,
          title: postData.mode === "Transfer" ? "Delivery Challan" : "GRN Invoice"
        }));
        navigate(`/invoices/${name}`);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, 'error', err.response?.data?.errors?.[0]?.message || 'Failed to generate invoice'));
      });
  };

  // Update postData on data change
  useEffect(() => {
    setPostData((prev) => ({
      ...prev,
      amount: Math.round(netTotal),
      gst_amt: gstAmt,
      roff: roundOff
    }));
  }, [data]);

  return (
    <Fragment>
  
          <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }}>Total</Typography>
          <div className="flex p-1">
                <Typography 
                textAlign="right" sx={{  paddingRight: 0.4, fontWeight: 600, fontSize: 36, width:'100%'}}          >
                  {Math.round(parseFloat(totalAmt + gstAmt || 0 )).toFixed(2)}
                </Typography>
              </div>
              <div className="my-2">
            <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF"}} > Summary </Typography>
            {/* <Design title="Sub Total" value={Math.round(parseFloat(totalAmt + gstAmt || 0)).toFixed(2)} /> */}
            <Design title="Sub Total" value={totalAmt || 0} />
            <Design title="GST Amt" value={gstAmt || 0}/>
            <Design title="Cess" value={cessAmt || 0}/>
            <Design title="Round Off" value={( Math.round(netTotal).toFixed(2) -netTotal || 0)}/>
            <Design title="Net Total" value={Math.round(netTotal) || 0}/>
          </div>
          <Stack  >
          {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="contained" 
          >Cancel</Button> */}
          <Button size="small" 
          sx={{margin:1 ,backgroundColor:"green !important",color:"black"}}
   
          startIcon={<Save/>} variant="contained" onClick={handleSubmit} 
          
          disabled={orderDetails1.length === 0}
          >Save</Button>
          <Button size="small" sx={{margin:1 ,backgroundColor:"red !important",color:"black"}} startIcon={<ExitToApp />} variant="contained" onClick={() => navigate('/')}>Exit</Button>
          </Stack>
      <Backdrop open={openDeleteDialog} sx={{zIndex:1350}} onClose={() => setOpenDeleteDialog(false)}>
  <DeletePage onCancel={setOpenDeleteDialog} onSubmit={cancelTransaction}/>
</Backdrop>
      </Fragment>
  );
};

export default memo(CustomerInfo);
